export const chartTranslations = [
  {
    name: 'en',
    options: {
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      toolbar: {
        exportToSVG: 'Download SVG',
        exportToPNG: 'Download PNG',
        exportToCSV: 'Download CSV',
        download: 'Download',
        selection: 'Selection',
        selectionZoom: 'Selection zoom',
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
        pan: 'Panning',
        reset: 'Reset zoom'
      }
    }
  },
  {
    name: 'pl',
    options: {
      months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
      shortMonths: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
      days: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'],
      shortDays: ['nd', 'pon', 'wt', 'śr', 'czw', 'pt', 'sob'],
      toolbar: {
        exportToSVG: 'Pobierz SVG',
        exportToPNG: 'Pobierz PNG',
        exportToCSV: 'Pobierz CSV',
        download: 'Pobierz',
        selection: 'Wybór',
        selectionZoom: 'Zoom',
        zoomIn: 'Przybliż',
        zoomOut: 'Oddal',
        pan: 'Przesuń',
        reset: 'Resetuj zoom'
      }
    }
  },
  {
    name: 'ru',
    options: {
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      shortMonths: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
      days: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
      shortDays: ['Вск', 'Пнд', 'Втр', 'Срд', 'Чтв', 'Птн', 'Сбт'],
      toolbar: {
        exportToSVG: 'Скачать SVG',
        exportToPNG: 'Скачать PNG',
        exportToCSV: 'Скачать CSV',
        download: 'Скачать',
        selection: 'Выбор',
        selectionZoom: 'Увеличение',
        zoomIn: 'Увеличить',
        zoomOut: 'Уменьшить',
        pan: 'Сдвинуть',
        reset: 'Сброс зума'
      }
    }
  }
];